import { useQuery } from '@tanstack/react-query';

import { useConsultaReembolsoContext } from '../contexts';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { ConsultaReembolso } from 'pages/financeiro/reembolso/consulta-reembolso/types';

export function useQueryConsultaReembolso() {
    const requestListagem = useRequestListagem();
    const { filter, autoLoad, sort, page, limit } = useListagemContext();
    const { setHasReembolsos } = useConsultaReembolsoContext();

    const requestOptions: RequestOptionsType = {
        url: '/financeiro/apuracaolojanotawrapper',
        sort: sort.length ? sort : [{ property: 'idPromocao', direction: 'DESC' }],
        nested: true,
        filter,
        limit,
        page,
    };

    return useQuery<RequestListagem<ConsultaReembolso[]>>(
        ['queryConsultaReembolso', requestOptions],
        () => requestListagem(requestOptions).then((res) => res.data),
        {
            enabled: autoLoad,
            onSettled: (data) => setHasReembolsos((data?.data?.length || 0) > 0),
        },
    );
}
